module.exports = __webpack_public_path__ + "media/assets/icons/funnel/star-active-ca6488ad61e2de8d0d0ddc92e623b082.svg";